/* eslint-disable */

import Phaser from 'phaser';
import { store } from '../stores/mainStore';
import { integration } from '../integration';
import { comm } from '../comm';
import { history } from '../history';
import { i18n } from '../i18n';
import { TutorialServer } from "../server/TutorialServer";
import {createAvatar, createCircleAvatar, shadowTextStyle, strokeTextStyle, updateMasks} from './uiElements';
import {addHandName} from './scoreCardElements';
import {OneHandResult} from './1handResult';
import {Tips} from './Tips';
//import {showSkillzScorecard} from './skillzScorecard';

var m;
export class UI {
	constructor(mgr) {
		m = mgr;
		this.goalArrow = null;
		this.goalArrowX = m.config.width / 2 - 480 * 0.3 * m.scaleFactor;
		this.goalArrowY = m.config.height * 0.18;
		this.defaultButtonHeight = 50 * 2;

		this.makeProfilePic = createAvatar;

		this.correctHandSound = 'sfx_good_hand';
		this.noHandSound = 'sfx_no_hand';
	}
	dodFontFamily = 'Jost'; // 'Oswald';

	skipTutorial(id) {
		store.modal = 'skipTutorial';
	}

	prepareTable() {
		console.log('8158 UI prepareTable')
		m.scene.load.reset();

		if (store.tutorialMode) {
			m.clearMessages();
			m.diceHand.unlockAllDice();
			m.diceHand.clearDiceOffScreen();
		}

		if((store.tutorialMode && (
				store.activeMatch.matchId === 'intro' 
				|| store.activeMatch.matchId === 'intro2'
				|| store.activeMatch.matchId === 'tutorial'
			)) || 
			(store.activeMatch.currentHand && !(store.activeMatch.currentHand.rollsRemaining === 3)))
			{
				m.scene.load.once('complete', function (file) {
					m.clearMessages();
					m.ui.showRoundBanner();
				});
				m.scene.load.start();
				return;
		}

		const turn = store.activeMatch.handNumber > 6 ? 3 : store.activeMatch.handNumber > 3 ? 2 : 1;
		const filename = store.tutorialMode ?
			(store.activeMatch.matchId === 'intro2' 
				? 'practice.png' : 'practice_game.png')
			: store.is3HandGame ? 'turn_indicator_3_hand.png' 
			: store.is1HandGame ? 'turn_indicator_1_hand.png' 
			: 'turn_indicator_' + turn + '.png';
		const topImage = m.scene.add.image(
			m.config.width / 2,	 300 * m.scaleFactor,
			'language',	filename
		).setScale(m.oldAssetScaleFactor * 1.3).setDepth(4);
		m.scoreCardElements.push(topImage);
		m.scene.load.start();
	}

	showSettingsButton = show => {
		m.ui.settingsBtn.visible = show;
	}
	enableSettingBtn = enable => {
		m.ui.settingsBtn.setAlpha(enable ? 1 : 0.5)
		if(enable)		m.ui.settingsBtn.setInteractive({useHandCursor: true})
		else 			m.ui.settingsBtn.disableInteractive()
	}

	showGoalArrow = () => {
		console.log('8158 UI showGoalArrow')
		var oldY = m.handBanner.y;
		var offset = 0;
		this.goalArrow = m.scene.add.sprite(this.goalArrowX-30, oldY + offset, 'language', 'goal_arrow.png');
		this.goalArrowY = this.goalArrow.y;
		this.goalArrow.setScale(m.oldAssetScaleFactor * (m.landscape ? 0.9 : 1.0)).setDepth(6).setAlpha(0);

		this.settingsBtn = m.scene.add.sprite(0.94*m.config.width, 200, 'settings')
			.setDepth(3).setAlpha(0)
			.on('pointerup', () => {
				store.showSkillzSettings = 'settings';
			})

		m.scoreCardElements.push(this.goalArrow);
		m.scene.tweens.add({
			targets: [this.goalArrow, this.settingsBtn], duration: 300, alpha: 1,
			onStart: () => m.ui.animateGoalArrow(),
			onComplete: () => this.enableSettingBtn(true)
		})
	}
	animateGoalArrow() {
		console.log('8158 UI animateGoalArrow')
		let showIt = (store.tutorialMode && store.activeMatch.matchId === 'intro2' && 
			store.activeMatch.handNumber === 1 
			&& store.activeMatch.currentHand.rollNumber === 0);
		const showBanner = store.activeMatch.currentHand && store.activeMatch.currentHand.rollsRemaining === 3;
		if(!showIt) {
			if(showBanner)	{
				/* const goalName = store.activeMatch.goals[store.activeMatch.handNumber - 1];
				if(store.hasCasualNames && i18n.exists(goalName + '_POKER')) {
					if(store.tutorialMode) {
						m.ui.showTutorialNamesHint();
					/* } else if(localStorage.getItem('seenNamesHint') !== 'true') {
						m.ui.showAvaNamesHint(); * /
					} else {
						this.showRoundBannerText();
					}
				} else { */
					store.showPaylineId = store.activeMatch.currentHand.bestHandTarget;
				//}
			}
			return;
		}
		if (this.goalArrowTween != null) this.goalArrowTween.stop();
		if (this.goalArrowTween2 != null) this.goalArrowTween2.stop();
		this.goalArrowTween = m.scene.tweens.add({
			targets: [this.goalArrow],
			x: m.handBanner.x - 182 * m.scaleFactor,
			y: this.goalArrow.y,
			//   ease        : 'Expo.easeIn',
			ease: 'Linear',
			duration: 600,
			repeat: 0,
			callbackScope: this.goalArrowTween,
			completeDelay: 0,
			onComplete: (tween, target) => {
				if(showBanner && !m.roundBanner)	this.showRoundBannerText();
				this.goalArrowTween2 = m.scene.tweens.add({
					targets: [this.goalArrow],
					x: this.goalArrowX,
					y: this.goalArrowY,
					//   ease        : 'Expo.easeIn',
					ease: 'Linear',
					duration: 280,
					repeat: 0,
					callbackScope: this.goalArrowTween,
					completeDelay: 0,
					onComplete: (tween, target) => {
						this.animateGoalArrow();
					},
					onCompleteScope: this.goalArrowTween2,
				});
			},
			onCompleteScope: this.goalArrowTween,
		});
	}
	killGoalArrow() {
		console.log('8158 UI killGoalArrow')
		if (this.goalArrow != null) this.goalArrow.destroy();
		if (this.goalArrowTween != null) this.goalArrowTween.stop();
		if (this.goalArrowTween2 != null) this.goalArrowTween2.stop();
		this.goalArrowTween = null;
		this.goalArrowTween2 = null;
	}
	afterPayTablePrematch() {
		console.log('8158 UI afterPayTablePrematch')
		Tips.showTip(Tips.NAMES.GOAL, 0.3* m.config.height)
		this.showRoundBannerText();		
	}

	showTutorialNamesHint() {
		console.log('8158 UI showTutorialNamesHint')
		m.ui.createTutorialBox('skilz_tutorial_names_hint', m.config.height * 0.3);

		const btn = m.ui.createButton( 'btn_next.png', 0,
			m.avaPanel.getBounds().height/2 + 0.5* m.ui.defaultButtonHeight,
			(480 * m.scaleFactor) / 5, m.ui.defaultButtonHeight,
			'ok',
			() => {
				m.ui.clearAvaPanel();
				m.ui.showRoundBannerText();
			}
		);
		m.avaPanel.add(btn);
		setTimeout(() => {m.ui.makePulsate(btn)}, 1000);

		m.ui.addHintArrow();
	}
	addHintArrow(delay = 0) {
		console.log('8158 UI addHintArrow')
		const arrow = m.scene.add.sprite(0, 0, 'whiteArrow').setScale(0.3 * m.scaleFactor);
		const botPos = m.avaPanel.getBounds().top - arrow.displayHeight/2;
		const topPos = m.handBanner.getBounds().bottom + arrow.displayHeight/4;
		const locBottom = m.avaPanel.getLocalPoint(0, botPos)
		const locTop = m.avaPanel.getLocalPoint(0, topPos)
		
		m.scene.tweens.add({ targets: [arrow], 
			y: {from: locBottom.y, to: locTop.y}, 
			duration: 1000, delay,
			repeat: -1, yoyo: true,})
		m.avaPanel.addAt(arrow, 0);
		return arrow
	}
	showAvaNamesHint() {
		console.log('8158 UI showAvaNamesHint')
		m.ui.clearAvaPanel();
		m.avaPanel = m.scene.add.container(m.config.width/2, 0).setDepth(5);
		const onClose = () => {
			m.ui.clearAvaPanel();
			m.ui.showRoundBannerText();
			window.setPersistentStorage('seenNamesHint', 'true');
		}

		const box = m.scene.add.container(m.config.width, 0);
		box.add(m.ui.createTextBox('skilz_ava_names_hint', 
			[{fill: '#3d4284', strokeThickness: 0},
			'ava_hint_bubble', 0.5, ()=> {
				store.skillzTimeTicking = false;
				onClose();
				store.showSkillzSettings = 'custom';
			}]
		));
		m.avaPanel.add(box)
		
		const btn = m.ui.createButton('btn_ok.png', 0.15* m.config.width,
			m.avaPanel.getBounds().height/2 + 0.5* m.ui.defaultButtonHeight,
			(480 * m.scaleFactor) / 5, m.ui.defaultButtonHeight,
			'ok', onClose);
		m.avaPanel.add(btn);

		const avaPic = m.scene.add.image(-m.config.width, 40 * m.scaleFactor, 'ava_hint_body')
			.setOrigin(0.5, 0).setDepth(7);
		m.avaPanel.add(avaPic);	
		m.avaPanel.setY(m.config.height - avaPic.getBounds().bottom)

		//const arrow = m.ui.addHintArrow(500).setAlpha(0);

		const tl = m.scene.tweens.timeline({ onComplete: () => {setTimeout(() => {m.ui.makePulsate(btn)}, 1000)}})
			.add({targets: [avaPic], x: 0, duration: 250})
			.add({targets: [box], x: 0, duration: 250})
			//.add({targets: [arrow], alpha: 1, duration: 100})
			.add({targets: [btn], scale: {start: 0, to: 1}, duration: 250})
		tl.play();
	}

	clearAvaPanel() {
		console.log('8158 UI clearAvaPanel')
		if (m.avaPanel != null) m.avaPanel.destroy();
	}
	tutorialStraightText =
		'You got a Straight in 1 roll!\nYou have 2 more rolls to\nimprove to a\nhigher-ranking Straight';
	createAvaPanel(x, y, text, showFace, image) {
		console.log('8158 UI createAvaPanel')
		m.ui.clearAvaPanel();
		m.avaPanel = m.scene.add.container(x - m.config.width, y);
		m.avaPanel.setDepth(5);

		let panel = m.scene.add.sprite(0, 0, 'tutorial', image + '.png'); // 'tutorialMatchPanel');
		panel.setScale(0.675 * m.scaleFactor);
		m.avaPanel.add(panel);
		
		m.scene.tweens.add({ targets: [m.avaPanel], x: x, ease: 'Linear', duration: 200 });
		return m.avaPanel;
	}
	avaPanelPos = 0.68;
	createTextBox  = (textKey, styles=[{}], img='tutorial_box', picScale = 0.675, onClick = null) => {
		console.log('8158 UI createTextBox', textKey)
		const tipPanel = m.scene.add.image(0, 0, img).setScale(picScale * m.scaleFactor);
		const placeBounds = Phaser.Geom.Rectangle.Scale(tipPanel.getBounds(), 0.9, 0.75);
		const calcTextBounds = arr => arr.reduce((rect, part) => Phaser.Geom.Rectangle.MergeRect(rect, part.getBounds()), new Phaser.Geom.Rectangle())

		let fontSize = 50;
		let lines = this.createTexts(textKey, fontSize, styles).flat(), bounds = calcTextBounds(lines);
		const scale = Math.min(placeBounds.width/bounds.width, placeBounds.height/bounds.height)
		lines.forEach(ch => ch.destroy())
		styles.forEach(style => {
			if(style.font) {
				const vals = style.font.split(" ")
				vals[1] = vals[1].slice(0,-2) * scale + 'px';
				style.font = vals.join(" ")
			}
			if(style.strokeThickness)
				style.strokeThickness *= scale
		})
		lines = this.createTexts(textKey, fontSize * scale, styles).flat();

		bounds = calcTextBounds(lines);
		lines.forEach(ch => ch.y -= bounds.height/2 + 0.04*tipPanel.getBounds().height);
		
		return [tipPanel, ...lines]
	}
	createTutorialBox(textKey, y, inTimeline = false, time = 200, pause = 0) {
		console.log('8158 UI createTutorialBox', textKey, 'y =', y)
		m.ui.clearAvaPanel();
		m.avaPanel = m.scene.add.container(-m.config.width/2, y).setDepth(5);
		m.avaPanel.add(m.ui.createTextBox(textKey, 
			[{}, {...strokeTextStyle(900, 50), strokeThickness: 4}]));
		const tweenConfig = {targets: [m.avaPanel], duration: time, 
			x: {start: -m.config.width/2, to: m.config.width/2},
			completeDelay: pause
		}
		return inTimeline ? tweenConfig : m.scene.tweens.add(tweenConfig)
	}
	createTexts = (textKey, fs, styles) => {
		const txtArr = i18n.t(textKey).split('*');
		let lineBounds = new Phaser.Geom.Rectangle(0, 0, 0, 0);
		return txtArr.map(txt => {
			if(txt === 'p' || txt ==='br') {
				const dy = (txt === 'p' ? 0.5 : -0.1)*fs
				lineBounds.bottom += dy;
				return false
			} else {
				const textPart = (str, x, y, style = styles[0]) => m.scene.add.text(x, y, str, {
						font: '700 '+fs+'px ' + m.ui.dodFontFamily, align: 'center', 
						fill: '#ffffff', stroke: '#6e2411', strokeThickness: 6,
						...style
					}).setOrigin(0);

				let partBounds = new Phaser.Geom.Rectangle(0, lineBounds.bottom, 0, 0);
				const parts = txt.split(/\[|\]/gi).map(str => {
					let res;
					if(str.startsWith('click')) {
						const txtName = str.split(' ').pop();
						res = textPart(i18n.t(txtName), partBounds.right, lineBounds.bottom)
							.setFill('#0000ff')
							.setInteractive({cursor: 'pointer'})
							.on('pointerup', () => { if(onClick)	onClick();})
					} else if(str.startsWith('pic')) {
						const picName = str.split(' ').pop();
						res = m.scene.add.image(partBounds.right, lineBounds.bottom, picName).setOrigin(0)
						res.setScale(1.7 * fs / res.height);
					} else if(str.startsWith('style')) {
						const arr = str.split(' ')
						const textStyle = styles[arr[1]] || {}
						res = textPart(i18n.t(arr[2]), partBounds.right, lineBounds.bottom, textStyle)
					} else {
						res = textPart(str, partBounds.right, lineBounds.bottom, styles[0] || {});
					}
					Phaser.Geom.Rectangle.MergeRect(partBounds, res.getBounds());
					return res;
				});

				parts.forEach(ch => {
					ch.x -= partBounds.width/2;
					ch.y += partBounds.height/2 - ch.getBounds().height/2
				});
				Phaser.Geom.Rectangle.MergeRect(lineBounds, partBounds);
				return parts
			}
		}).filter(Boolean)
	};

	makePulsate(obj, dur=750, size=1.15, repeat=true, complete = () => { return }) {
		console.log('8158 UI makePulsate')
		let scale = obj.scaleX;
		let tween = m.scene.tweens.add({
			targets: [obj],
			scaleX: scale * size,
			scaleY: scale * size,
			//   ease        : 'Expo.easeIn',
			ease: 'Linear',
			duration: dur,
			repeat: (repeat ? -1 : 0),
			yoyo: true,
			onComplete: (tween, target) => {
				complete();
			},
		});
		m.scoreCardTweens.push(tween);
		return tween;
	}

	startMatch = () => {
		console.log('8158 UI startMatch id =', store.activeMatch.matchId)

		m.gameHud = {hudBackHeight: 139};
		m.pinkHeart = {x: m.config.width - 35, y: m.handBannerPosition - m.gameHud.hudBackHeight + 3}
		m.startSideLoading();

		if (store.tutorialMode && store.activeMatch.matchId === 'intro') {
			m.diceHand.introDiceIntoCup();
		} else {
			//m.ui.prepareTable();
			m.scene.load.once('complete', function (file) {
				m.clearMessages();
				//	m.ui.prematchAnimation(); no prematch animation in MG2
				m.ui.showRoundBanner()
			});
			m.scene.load.start();
		}
	}

	createGradientText = (text = '', fontSize = 110) => {
		const txt = m.scene.add.text(0, 0, text, {font: `900 ${fontSize}px ${m.ui.dodFontFamily}`}).setOrigin(0.5, 1)
			.setFontStyle('bold italic').setPadding({ right: 20})
			.setStroke('#ffffff', 4).setShadow(0, 8, '#00000073', 5, true, false)

		const gradient = txt.context.createLinearGradient(0, 0, 0, txt.height);
		gradient.addColorStop(0.6, '#ffffff');
		gradient.addColorStop(0.8, '#b1b1b1');
		txt.setFill(gradient)
		m.scoreCardElements.push(txt);		
		
		return txt
	}
	prematchAnimation = () => {
		console.log('8158 PREMATCH starts :: opp =', store.activeMatch.opponent)
		const avaSize = Math.min(0.3 * m.config.width, 0.2*m.config.height);
		const clashY = 0.55 * m.config.height - avaSize;
		
		const me = createCircleAvatar(-0.3*m.config.width, 
			clashY, avaSize, 'profile_default', i18n.t('You'))
		const opp = createCircleAvatar(1.3*m.config.width, 
			clashY, avaSize, 'oppAvatar', store.activeMatch.opponent.name)
		const vs = this.createGradientText(i18n.t('vs'), 120).setScale(0)
			.setPosition(0.5*m.config.width, clashY).setOrigin(0.5)

		const {popup, myCoin, oppCoin, prizeCoin, prizeCoinPuff, myWagerTxt, oppWagerTxt, prizeTxt, balanceTxt} = this.createStakeSettle();
		popup.setScale(0);
		[oppCoin, myCoin, prizeCoin, prizeCoinPuff].forEach(v => v.setAlpha(0.25));
		[myWagerTxt, oppWagerTxt, prizeTxt].forEach(txt => txt.text = '')
		balanceTxt.setText(store.tresCommas(store.balance));

		const ready = this.createGradientText(i18n.t('get_ready'), 150)
			.setPosition(0.5*m.config.width, 1.1*m.config.height)
			.setDepth(20)

		// stars
		const stars = m.scene.add.sprite(vs.x, vs.y, 'poof').setScale(0).setDepth(6);
		//m.scoreCardElements.push(stars);

		const t1 = 300, t2 = 150, t3 = 600, t4 = 300, 
			tApp = 100, tCoin = 500, tUp = 500
		const counterAnim = (txt, from, to) => { return {
			targets: [txt], duration: tCoin, 
			value: {from, to, ease: 'Linear'},
			onUpdate: () => {txt.text = store.truncateValue(Math.round(txt.value))}
		}}
		const flow = m.scene.tweens.timeline({ 
			onComplete: () => {
				store.balance -= store.bet
				m.ui.showRoundBanner()
			},
			completeDelay: 300
		})
			.add({targets: [me.avatar, me.ring, me.plateCont], 
				x: 0.5*m.config.width - 0.5*avaSize, duration: t1
			})
			.add({targets: [opp.avatar, opp.ring, opp.plateCont], 
				x: 0.5*m.config.width + 0.5*avaSize, 
				duration: t1, offset: 0,
				onUpdate: () => updateMasks([me.avatar, opp.avatar], avaSize)
			})
			.add({targets: vs, scale: 1, duration: t2, onStart: () => {
				m.playAudio('bumper');
				stars.setScale(2.65 * m.scaleFactor);
				stars.on('animationcomplete', () => stars.destroy());
				stars.anims.play('poof');
			}})
			.add({targets: [me.avatar, me.ring, me.plateCont], 
				x: 0.25*m.config.width, ease: 'Back.easeOut',
				duration: t2, offset: '-='+t2})
			.add({targets: [opp.avatar, opp.ring, opp.plateCont], 
				x: 0.75*m.config.width, ease: 'Back.easeOut',
				duration: t2, offset: '-='+t2,
				onUpdate: () => updateMasks([me.avatar, opp.avatar], avaSize)
			})

			.add({targets: [popup], scale: 1, duration: tApp})

			.add({targets: [myCoin, oppCoin], alpha: 1, duration: tCoin,
				onStart: () => {
					const time = tCoin / 1000;
					const myRect = myCoin.getBounds()
					const oppRect = oppCoin.getBounds()
					store.coinAnimation = {
						from: me.avatar.getCenter(),
						to: {x:myRect.left, y:myRect.top}, 
						time, value: 0, coins: 3
					}
					store.coinAnimation2 = {
						from: opp.avatar.getCenter(),
						to: {x:oppRect.left, y:oppRect.top}, 
						time, value: 0, coins: 3
					}
					m.playAudio('Coins_v5c');
				}
			})
			.add({...counterAnim(myWagerTxt, 0, store.bet), offset: '-=' + tCoin})
			.add({...counterAnim(oppWagerTxt, 0, store.bet), offset: '-=' + tCoin})
			.add({...counterAnim(balanceTxt, store.balance, store.balance - store.bet), offset: '-=' + tCoin})

			//.add({targets: [prizeCoin, prizeCoinPuff], alpha: 1, duration: tApp, offset: '-=0'})
			//.add({...counterAnim(prizeTxt, 0, store.prize), offset: '-=' + tApp})

			.add({targets: [prizeCoinPuff], scale: 1.5, alpha: 0.001,
				duration: 250, offset: '+=' + 250,
				onStart: () => {
					prizeCoin.setAlpha(1);
					prizeTxt.setText(store.truncateValue(2*store.bet)).setAlpha(1);
					prizeCoinPuff.setAlpha(1);
				},
				/* onStart: () => {
					/* const time = Math.min(0.01*store.prize, tCoin / 1000)
					const myRect = myCoin.getBounds()
					const oppRect = oppCoin.getBounds()
					const przRect = prizeCoin.getBounds()
					store.coinAnimation = {
						from: {x:myRect.left, y:myRect.top}, 
						to: {x:przRect.left, y:przRect.top}, 
						time, value: 0, coins: 3
					}
					store.coinAnimation2 = {
						from: {x:oppRect.left, y:oppRect.top}, 
						to: {x:przRect.left, y:przRect.top}, 
						time, value: 0, coins: 3
					} * /
					m.playAudio('Coins_v5c');
				} */
			})
		
		const moveMultichip = () => {
			const rect = m.ui.multiChip.getBounds();
			popup.remove(m.ui.multiChip);
			m.ui.multiChip.setDepth(m.ui.multiChip.displayList.length)
			m.scene.tweens.add({
				targets: [m.ui.multiChip],
				x: {from: rect.centerX, to: m.config.width - 10 - rect.width},
				y: {from: rect.centerY, to: m.config.height - 10 - rect.height},
				duration: 2000
			})			
		}
		if(store.isMultipliedGame) { 	flow
			.add({targets: [m.ui.multiChip],
				x: prizeCoin.x + 125,
				y: prizeCoin.y + 5,
				duration: 250, offset: '+=' + 0,
				onComplete: moveMultichip
			})
			.add({targets: [prizeCoinPuff], 
				scale: {from: 0.33, to: 1.5}, 
				alpha: {from: 1, to: 0},
				duration: 250, offset: '+=' + 0,
				onStart: () => {
					prizeTxt.setText(store.truncateValue(store.prize)).setAlpha(1);
				},
			})
		} else {	flow
			.add({
				value: {from: 0, to: 1}, targets:[this], duration: 50,
				onStart: () => {
					store.showMultiplierAnimation = false;
					moveMultichip()
				}
			})
		}
			
		flow.add({targets:[popup], y: '-=' + m.config.height, alpha: 0, duration: tUp, offset: '+='+1000 })
			.add({targets: ready, y: clashY, offset: '-=' + tUp/2,
				duration: t3, ease: 'Back.easeOut',
				onStart: () => m.playAudio('Transition_subtleWhoosh_v2a')
			})
			.add({targets: vs, scale: 0, duration: t2, offset: '-='+t4})
			.add({targets: [me.avatar, me.ring, me.plateCont], 
				x: -0.3*m.config.width, ease: 'Quad.easeOut',
				duration: t4, offset: '-='+t4})
			.add({targets: [opp.avatar, opp.ring, opp.plateCont], 
				x: 1.3*m.config.width,ease: 'Quad.easeOut',
				duration: t4, offset: '-='+t4,
				onUpdate: () => updateMasks([me.avatar, opp.avatar], avaSize)
			})
			.add({targets: ready, scale: '*='+3, alpha: 0, duration: t1})

		flow.play();
	}
	createStakeSettle = () => {
		const y = m.config.height * 3/4;
		const addCoin = (x, y) => m.scene.add.image(x, y, 'coin').setScale(.33);
		const popup = m.scene.add.container(m.config.width/2, y).setDepth(5);

		const scale = Math.min(
			0.85 * m.config.width / 1170,
			0.45 * m.config.height / 1140,
		);
		const panel = m.scene.add.image(0, 0, 'stakePanel').setScale(scale); 
		const panelW = 0.94 * panel.getBounds().width; 
		const panelH = 1140/1170 *panelW;
		const yStake = -0.2*panelH, yPrize = 0.03*panelH, yBalance = 0.32 *panelH;
		
		const title = m.scene.add.text(0, -0.46* panelH, i18n.t('stakes').toUpperCase(), shadowTextStyle(800, 70)).setOrigin(0.5);
		const myCoin = addCoin(-0.36 *panelW, yStake); 
		const myWagerTxt = m.scene.add.text(-0.29 *panelW, yStake-5, '1000', shadowTextStyle()).setOrigin(0, 0.5);
		const oppCoin = addCoin(0.1 *panelW, yStake); 
		const oppWagerTxt = m.scene.add.text(0.17 *panelW, yStake-5, '1000', shadowTextStyle()).setOrigin(0, 0.5);

		const prizeLabel = m.scene.add.text(-0.4 *panelW, yPrize, i18n.t('prize_colon'), shadowTextStyle()).setOrigin(0, 0.5);
		const prizeCoin = addCoin(prizeLabel.getBounds().right + 20, yPrize).setOrigin(0, 0.5);
		const prizeCoinPuff = addCoin(prizeLabel.getBounds().right + 50, yPrize).setOrigin(0.5);
		const prizeTxt = m.scene.add.text(prizeCoin.getBounds().right + 15, yPrize, '1000', shadowTextStyle()).setOrigin(0, 0.5);
		m.ui.multiChip = m.scene.add.image(0.3 *panelW, yPrize - 70, 'multi_'+store.multiplier).setScale(.15)
			.setVisible(!store.isMultipliedGame)

		const winner = this.createTexts('winner_take', 40, 
			[strokeTextStyle(500, 36), strokeTextStyle(700, 40)])[0]
			.map(txt => txt.setY(txt.y + 0.17*panelH).setOrigin(0, 0.5))

		const balanceLabel = m.scene.add.text(-0.36 *panelW, 0.27*panelH, i18n.t('balance'), strokeTextStyle(500, 30)).setOrigin(0, 1);
		const balanceCoin = addCoin(-0.4*panelW, yBalance).setOrigin(0.5)//.setScale(0.25);
		const balanceTxt = m.scene.add.text(-0.33 *panelW, yBalance, "1000", shadowTextStyle(600, 40)).setOrigin(0, 0.5);

		popup.add([panel, title, myCoin, myWagerTxt, oppCoin, oppWagerTxt, prizeLabel, prizeCoin, prizeTxt, ...winner, balanceLabel, balanceCoin, balanceTxt, m.ui.multiChip, prizeCoinPuff]);
		store.multiChipRect = m.ui.multiChip.getBounds();

		return {popup, myCoin, oppCoin, prizeCoin, prizeCoinPuff, myWagerTxt, oppWagerTxt, prizeTxt, balanceTxt}
	}

	bumperDelay = 200;
	startBumperDelay = () => {
		console.log('8158 UI startBumperDelay')
		this.bumperPlaying = true;
		gameSetTimeout(() => {
			this.bumperPlaying = false;
		}, this.bumperDelay);
		this.bumperDelay = 150;
	};
	collisionStars = (x, y) => {
		if (!this.bumperPlaying) {
			var lilStars = m.scene.add.sprite(x, y, 'poof');
			lilStars.setDepth(2);
			m.scoreCardElements.push(lilStars);
			m.playAudio('bumper');
			lilStars.anims.play('poof', true);
			this.startBumperDelay();
		}
	};

	inGameAfterInterstitial = false;

	showSkipButton () {
		console.log('8158 UI \t showSkipButton')
		//if(store.wrapperDebugMsg !== '' || window.location.hostname === 'localhost') {
		m.skipTutorial = m.ui.createButton(
			'btn_skip_tutorial.png',
			m.config.width - 100 * 2,
			m.config.height - 40 * 2,
			480 * 2 * 0.35,
			m.ui.defaultButtonHeight,
			'skip-practice',
			function (pointer) {
				console.log('skip tutorial');
				window.setPersistentStorage('skippedTutorial', 'yes');
				store.activeMatch = null;
				history.push('/');
				store.tutorialMode = false;
			},
			'gray'
		);
		m.skipTutorial.setX(m.config.width - m.skipTutorial.getBounds().width/2);
		m.skipTutorial.setDepth(3);
		//}
	}

	showRoundBanner() {
		console.log('8158 UI showRoundBanner')
		m.clearMessages();
		m.diceHand.unlockAllDice();
		if(!(/* !store.isProd && */ store.custom.usePopper))
			m.diceHand.clearDiceOffScreen();

		if(store.botVideo)
			return;	// will continue after user closes board interstial, or store, or shopify modal.

		m.ui.inGameAfterInterstitial = false;
		if (!m.showInterstitialVideo()) 
			m.ui.continueShowRoundBanner();
	}
	continueShowRoundBanner() {
		console.log('8158 UI continueShowRoundBanner')
		m.ui.inGameAfterInterstitial = true;
		store.botVideo = false;

		const goalPanel = 'goalPanel';
		const goalX = m.config.width / 2, goalY = m.handBannerPosition;
		const goalWidth = 240 * 2, goalHeight =  50 * 2;
		const showBanner = store.activeMatch.currentHand && store.activeMatch.currentHand.rollsRemaining === 3;
		const isHighHand = false; //store.activeMatch.handNumber >= store.activeMatch.roundCount && !store.is3HandGame;

		const goalCont = m.scene.add.container(goalX, goalY);
		const back = m.scene.add.sprite(0, 0, goalPanel, 0)
			.setOrigin(0.5, 0.5).setScale(m.oldAssetScaleFactor);
		const anim = m.scene.add.sprite(0, 0, goalPanel)
			.setOrigin(0.5, 0.5).setScale(m.oldAssetScaleFactor);

		const index = store.activeMatch.matchId === 'intro2' ? 5 : store.activeMatch.handNumber - 1;
		const goalName = isHighHand ? "highest-hand" : store.activeMatch.goals[index];
		const finalHand = addHandName(0, 100, goalName, 60, 0.8*goalWidth);
		const zoomHand = addHandName(0, 0, goalName, 60, 0.8*goalWidth).setAlpha(0);

		const shape = m.scene.make.graphics({ fillStyle: { color: 0x000000 }, add: false })
			.fillRectShape(new Phaser.Geom.Rectangle(goalX - goalWidth/2, goalY - goalHeight/2, goalWidth, goalHeight));
		anim.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape);
		finalHand.mask = new Phaser.Display.Masks.GeometryMask(m.scene, shape);
		goalCont.add([back, anim, finalHand, zoomHand]).setDepth(3);
		m.handBanner = goalCont;

		function helpDown() {
			this.downOnHelp = true;
			gameSetTimeout(() => {
				this.downOnHelp = false;
			}, 1000);
			this.y += 5;
			m.playAudio('poop');
			if (this.displayWidth < 200) {
				this.setFrame(1);
			}
		}
		function helpOut() {
			this.y = this.homeY;
		}
		function helpUp() {
			this.y = this.homeY;
			if (this.displayWidth < 200) {
				this.setFrame(0);
			}
			if (this.downOnHelp === true) {
				m.playAudio('pop');
				integration.postEvent('game_hand_help', 'gameplay')

				store.modal = 'hand';
				if (store.tutorialMode && store.tutorialState === 'handInfo') {
					store.tutorialState = '';
					store.tutorialPreventRoll = false;
					store.m.cup.reallyReturnCup(true);
				}
			}
		}
		m.handHelp = m.scene.add.sprite(goalX + 145 * 2, goalY, 'button_help')
			.setInteractive().setDepth(3).setScale(m.oldAssetScaleFactor * 0.75);
		m.handHelp.homeY = m.handHelp.y;
		m.handHelp.on('pointerdown', helpDown);
		m.handHelp.on('pointerup', helpUp);
		m.handHelp.on('pointerout', helpOut);

		if (store.tutorialMode && store.activeMatch.matchId === 'intro') {
			goalCont.setAlpha(0);
			//m.handBannerBack.setAlpha(0);
			//m.handBanner.setAlpha(0);
			m.handHelp.setAlpha(0);

			const rollTheDice = m.scene.add.sprite(m.config.width / 2, m.config.height * 0.425, 'short_tutorial_msg_roll');
			rollTheDice.setDepth(3);
			rollTheDice.setScale(0.75 * 2);
			m.scoreCardElements.push(rollTheDice);

			const continueRollTheDice = () => {
				m.cup.reallyFakeReturnCup(false);
				this.showSkipButton();
			}
			gameSetTimeout(continueRollTheDice, 500);
			return;
		}

		if (showBanner && !isHighHand) {
			anim.on('animationstop', (animation) => {
				anim.setAlpha(0);
				m.scene.tweens.add({ 
					targets: [finalHand], y: 0, 
					ease: 'Expo.easeOut', duration: 300,
					onComplete: () => this.showGoalArrow()
				});
			});
			m.playAudio('wheelSpinTicker');
			anim.anims.play('handSpin', true);
			setTimeout(() => { anim.anims.stopAfterRepeat(1) }, 400)
		} else {
			finalHand.setY(0);
			if(showBanner || isHighHand) {
				if(showBanner) {
					this.showGoalArrow();
					m.playAudio(isHighHand ? 'magic_poof_02' : 'twinkle');
					finalHand.setY(0);
					zoomHand.setAlpha(1);
					const scale = m.oldAssetScaleFactor*2.5;
					const bou = zoomHand.getBounds();
					m.scene.tweens.add({ targets: [zoomHand],
						scale: scale,
						x: - bou.width/2 * scale, 
						y: - bou.height/2 * scale, 
						alpha: 0.0,
						ease: 'Linear', delay: 150, duration: 750,
						onComplete: () => zoomHand.setAlpha(0)
					});
				}
				gameSetTimeout(m.cup.returnCup, 600);
			} 
		}

		if (store.tutorialMode && store.activeMatch.matchId === 'tutorial') {
			m.skipTutorial = m.ui.createButton(
				'btn_skip_tutorial.png',
				m.config.width - 100 * 2,
				m.config.height - 40 * 2,
				480 * 2 * 0.35,
				m.ui.defaultButtonHeight,
				'skip-practice',
				function (pointer) {
					console.log('skip tutorial');
					m.ui.skipTutorial();
				}, 
				'gray'
			);
			m.skipTutorial.setX(m.config.width - m.skipTutorial.getBounds().width/2);
			m.skipTutorial.setDepth(3);
		} else if(store.tutorialMode && store.activeMatch.matchId === 'intro2') {
			m.skipTutorial = null;
			this.showSkipButton();		
		} else 
			m.skipTutorial = null;

		if (!showBanner) {
			m.diceHand.restoreDiceFromResume();
			m.cup.returnCup();
		}
	}
	fadeGoalBanner = show => {
		m.scene.tweens.add({
			targets: [m.handBanner, m.handBannerBack, m.handHelp],
			alpha: show ? 1 : 0,
			ease: 'Linear',
			duration: 200
		});
	}
	showRoundBannerText() {
		console.log('8158 UI showRoundBannerText')
		m.roundBanner = this.createGradientText()
			.setPosition(1.5*m.config.width, m.handBanner.y + 220)
			.setText(i18n.t('skilz_goal_num')
				.replace('*num*', store.activeMatch.handNumber)
				.replace('*total*', store.activeMatch.roundCount))

		if(store.activeMatch.matchId === 'intro2' || store.is1HandGame) {
			m.roundBanner.setAlpha(0);
			gameSetTimeout(m.ui.showAvaIntroBanner, 200);
		} else {
			m.cup.returnCup();
			/* let roundTween = m.scene.tweens.add({
				targets: [m.roundBanner],
				x: m.config.width / 2,
				delay: 250,		duration: 300,
				onComplete: () => {
					var lilStars = m.scene.add.sprite(m.roundBanner.x, m.roundBanner.y, 'poof');
					lilStars.setScale(2.65 * m.scaleFactor);
					lilStars.setDepth(6);
					m.scoreCardElements.push(lilStars);
					lilStars.anims.play('poof', true);

					const roundBannerCopy = createRoundBannerText().setX(m.roundBanner.x)
					const goNext = () => {
						if (store.tutorialMode 
							&& store.activeMatch.handNumber === 1 
							&& store.activeMatch.currentHand.rollNumber === 0) 
						{
							if(store.activeMatch.matchId === 'intro2') {
								gameSetTimeout(m.ui.showAvaIntroBanner, 200);
							} else {
								m.cup.returnCup();
								m.cup.reallyFakeReturnCup(true);	
							}
						} else {
							m.cup.returnCup();
						}
					}
					m.scoreCardTweens.push(m.scene.tweens.add({
						targets: [roundBannerCopy],
						scale: 3, alpha: 0.0,
						ease: 'Linear', duration: 700, delay: 50,
						onComplete: () => {
							if(!store.isProd && !store.tutorialMode && store.custom.usePopper) {
								this.hideRoundBannerText(goNext)
							} else goNext();
						}
					}));
				},
			});
			m.scoreCardTweens.push(roundTween); */
		}
	}
	hideRoundBannerText(onComplete) {
		console.log('8158 UI hideRoundBannerText')
		if(!m.roundBanner)	return;
		m.scene.tweens.add({
			targets: [m.roundBanner],
			x: '-=' + m.config.width,
			duration: 300,	onComplete
		})
	}

	showAvaIntroBanner() {
		console.log('8158 UI showAvaIntroBanner')
		if (m.roundBanner != null) m.roundBanner.setAlpha(0);
		if (m.turnBanner != null) m.turnBanner.setAlpha(0);

		m.ui.createAvaPanel(
			m.config.width / 2,
			m.adjustY(852) * 0.345,
			'You have 3 rolls to\nget the assigned hand.\nTap ? to learn more.',
			true,
			'tutorial_2'
		);

		let arrow = m.scene.add.sprite(145 * 2, m.adjustY(-120), 'common', 'arrow_gold.png');
		arrow.setScale(0.45 * m.scaleFactor);
		m.avaPanel.add(arrow);

		let tutCont = m.ui.createButton(
			'btn_next.png',
			130 * 2,
			m.avaPanel.getBounds().top - m.ui.defaultButtonHeight/2, //m.adjustY(35),
			(480 * m.scaleFactor) / 5,
			m.ui.defaultButtonHeight,
			'next',
			function (pointer) {
				console.log('tutorial roll continue');
				m.ui.clearAvaPanel();
				m.roundBanner.setAlpha(1);
				if (m.turnBanner != null) m.turnBanner.setAlpha(1);
				m.cup.returnCup();
				m.cup.reallyFakeReturnCup(true);
			}
		);
		m.ui.makePulsate(tutCont);

		gameSetTimeout(() => {
			m.ui.makePulsate(m.handHelp, 300, 1.5, false);
		}, 700);


		m.avaPanel.add(tutCont);
	}

	showToast(text) {
		console.log('8158 UI showToast')
		const fontSize = 50, bottomY = m.handBanner.getBounds().bottom;
		const dim = m.scene.add.graphics().setDepth(7)
			.fillStyle(0x000000, 0.5)
			.fillRect(0, 0, m.config.width, bottomY)
		dim.y -= bottomY;
		const txt = m.scene.add.text(m.config.width/2, -fontSize, text, {
			font: '900 ' + fontSize + 'px ' + m.ui.dodFontFamily,
			fill: '#ffffff'
		}).setOrigin(0.5, 1).setDepth(7)
		m.playAudio('magic_poof_02')
		m.scene.tweens.add({ targets: [dim, txt], y: '+=' + bottomY, 
			duration: 250, yoyo: true, hold: 2000
		})
	}

	endOfTutorialSequence(finishedTutorial) {
		console.log('8158 UI endOfTutorialSequence')
		var promise = Promise.resolve();
		promise = comm.FinishTutorial(true).then(() => {
			m.ui.endTutorial();
			m.ui.fadeScorecard();
			m.ui.continueButtonContainer.destroy();
			return;
		});
		return;
	}

	tutorialBanner = null;
	showTutorialBanner() {
		console.log('8158 UI showTutorialBanner')
		if (!m.landscape) return;
		if (!m.landscape)
			this.tutorialBanner = m.scene.add.sprite(m.config.width / 2, 30 * m.scaleFactor, 'tutorialBanner');
		else this.tutorialBanner = m.scene.add.sprite(m.pinkHeart.x, m.pinkHeart.y + 62 * m.scaleFactor, 'tutorialBanner');
		this.tutorialBanner.setDepth(4);
		this.tutorialBanner.setScale(0.5 * m.scaleFactor);
		this.tutorialBanner.setAlpha(0.0);

		m.scene.tweens.add({
			targets: [this.tutorialBanner],
			alpha: 1.0,
			ease: 'Linear',
			duration: 200,
			repeat: 0,
		});
	}
	hideTutorialBanner() {
		console.log('8158 UI hideTutorialBanner')
		if(!(store.tutorialMode && store.activeMatch?.matchId === 'intro2' && store.activeMatch.currentHand.rollNumber < 2))
			m.skipTutorial?.setAlpha(0);
		if (this.tutorialBanner != null) this.tutorialBanner.destroy();
	}

	showScorecard(handNumber, viewOnly) {	
		console.log('8158 UI ------------------ showScorecard')
		store.showPaytable = 'showResult';
		store.movePaylineBack = true;

		//showSkillzScorecard(handNumber, viewOnly);
		store.skillzTimeTicking = false;
		//store.showSummary = true;
		//m.scoreCardElements.push(new OneHandResult(m.scene, store.activeMatch, m));
	}
	addGlowToButton(button) {
		console.log('8158 UI addGlowToButton')
		const leftPic = button.leftPic;
		const midlPic = button.midlPic;
		const rightPic = button.rightPic;
		const leftGlow = m.scene.add.sprite(leftPic.x, leftPic.y, 'common', 'btn_glow_left.png').setOrigin(1, 0.43).setScale(leftPic.scaleX, leftPic.scaleY);
		const midGlow = m.scene.add.sprite(midlPic.x, midlPic.y, 'common', 'btn_glow_middle.png').setOrigin(0, 0.43).setScale(midlPic.scaleX, midlPic.scaleY);
		const rightGlow = m.scene.add.sprite(rightPic.x, rightPic.y, 'common', 'btn_glow_right.png').setOrigin(0, 0.43).setScale(rightPic.scaleX, rightPic.scaleY);
		button.leftGlow = leftGlow;
		button.midGlow = midGlow;
		button.rightGlow = rightGlow;
		button.add([leftGlow, midGlow, rightGlow]);
		leftGlow.setAlpha(0);
		midGlow.setAlpha(0);
		rightGlow.setAlpha(0);
	}
	activateGlowButton(button) {
		console.log('8158 UI activateGlowButton')
		const leftGlow = button.leftGlow;
		const midGlow = button.midGlow;
		const rightGlow = button.rightGlow;
		leftGlow.setAlpha(1);
		midGlow.setAlpha(1);
		rightGlow.setAlpha(1);
		var evapTween = m.scene.tweens.add({
			targets: [leftGlow, midGlow, rightGlow],
			alpha: 0.0,
			ease: 'Linear',
			delay: 0,
			duration: 500,
			yoyo: true,
			repeat: -1
		});
		m.scoreCardTweens.push(evapTween);
	}

	createButton(image, x, y, minWidth, height, text, pointerUpFunction, color='blue', iconLeft = '', iconRight='') {
		//console.log(' 3932 create button :: color =', color, 'text =', text, 'icon =', iconLeft, 'at', x, y, 'size =', minWidth, height)
		const assetH = 105;		// height of graphic asset
		const scaleH = 0.8* height / assetH;	// magic number to see buttons the same size as previous
		const fontSize = 50 * scaleH;
		const textStyle = {
			font: '800 ' + fontSize+'px '+ m.ui.dodFontFamily,
			align: 'center',
			fill: '#ffffff',
			shadow: {offsetX: 0, offsetY: 4 *scaleH, color: '#00000059', fill:true}
		}
		const hiddenIcon = iconLeft === 'small_star.png';

		const leftPic = m.scene.add.sprite(0, 0, 'common', 'btn_'+color+'_left.png').setOrigin(1, 0.43).setScale(scaleH);
		const midlPic = m.scene.add.sprite(leftPic.getBounds().right, 0, 'common', 'btn_'+color+'_middle.png').setOrigin(0, 0.43).setScale(scaleH);
		const rightPic = m.scene.add.sprite(midlPic.getBounds().right, 0, 'common', 'btn_'+color+'_right.png').setOrigin(0, 0.43).setScale(scaleH);
		const contentContainer = m.scene.add.container(0, 0);
		let leftIcon, rightIcon;
		if(iconLeft !== '') {
			leftIcon = m.scene.add.sprite(0, 0, 'common', iconLeft)
				.setOrigin(0, 0.5).setScale(scaleH)
				.setAlpha(hiddenIcon ? 0 : 1);
			const leftIconShadow = m.scene.add.sprite(leftIcon.x, leftIcon.y + textStyle.shadow.offsetY, 'common', iconLeft)
				.setOrigin(leftIcon.originX, leftIcon.originY).setScale(leftIcon.scale)
				.setTintFill(0).setAlpha(hiddenIcon ? 0 : 0.35);
			contentContainer.add([leftIconShadow, leftIcon]);
		}
		const txt = m.scene.add.text(
			leftIcon ? leftIcon.getBounds().right + 5*scaleH : 0, 0, 
			(i18n.t(text) || text).toUpperCase(), textStyle)
			.setOrigin(0, 0.5);
		if(txt.getBounds().height >= assetH*scaleH) {		
			// two lines text
			txt.setScale(0.8 * assetH*scaleH / txt.getBounds().height);
		}
		contentContainer.add(txt);

		if(iconRight !== '') {
			rightIcon = m.scene.add.sprite(txt.getBounds().right + 5*scaleH, 0, 'common', iconRight)
				.setScale(scaleH).setOrigin(0, 0.5);
			const rightIconShadow = m.scene.add.sprite(rightIcon.x, rightIcon.y + textStyle.shadow.offsetY, 'common', iconRight)
				.setOrigin(rightIcon.originX, rightIcon.originY).setScale(rightIcon.scale)
				.setTintFill(0).setAlpha(0.35)
			contentContainer.add([rightIconShadow, rightIcon]);
		}

		rightPic.setX(Math.max(
			minWidth - leftPic.getBounds().width - rightPic.getBounds().width,
			rightPic.getBounds().left, 
			rightIcon ? rightIcon.getBounds().centerX + 0.25*rightIcon.getBounds().width
				: txt.getBounds().right)
		);
		midlPic.setDisplaySize(rightPic.getBounds().left - midlPic.getBounds().left, midlPic.displayHeight);
		contentContainer.setX(midlPic.getBounds().centerX - contentContainer.getBounds().width/2);

		const picContainer = m.scene.add.container(0, 0)
			.add([leftPic, midlPic, rightPic])
		const buttonContainer = m.scene.add.container(x, y).setDepth(4)
		buttonContainer.bkgs = picContainer.getBounds();
		buttonContainer.add([leftPic, midlPic, rightPic, contentContainer])
			//.add([picContainer, contentContainer])
			.iterate(ch => ch.setX(ch.x - midlPic.getBounds().width/2));

		buttonContainer.leftPic = leftPic;
		buttonContainer.midlPic = midlPic;
		buttonContainer.rightPic = rightPic;	//save for adding glow later
	
		const hitButton = m.scene.add.sprite(0, 0, 'common', 'btn_red_middle.png')
			.setDisplaySize(buttonContainer.getBounds().width *1.2, buttonContainer.getBounds().height *1.5)
			.setInteractive().setAlpha(0.02);
		buttonContainer.add(hitButton);

		hitButton.debounce = text === 'skip-practice' || text === 'extra-roll' ? false : true;
		hitButton.moveButton = true;
		hitButton.offScreen = false;
		hitButton.buttonPressed = false;
		hitButton.downButtonPressed = false;
		hitButton.oldContainerY = hitButton.offScreen ? (buttonContainer.y - (m.config.height/2)) : buttonContainer.y;
		hitButton.container = buttonContainer;

		hitButton.on('pointerdown', function (pointer) {
			if ((this.debounce === true && this.buttonPressed === true) || this.downButtonPressed === true) return;
			this.downButtonPressed = true;

			if (this.moveButton) this.container.y = this.oldContainerY + 5;
			else this.container.setAlpha(0.5);
			m.playAudio('poop');
		});
		hitButton.on('pointerout', function (pointer) {
			if (this.debounce === true && this.buttonPressed === true) return;
			if (this.moveButton) this.container.y = this.oldContainerY;
			else this.container.setAlpha(1.0);
			this.buttonPressed = false;
		});
		hitButton.on('pointerup', function (pointer) {
			if (this.debounce === true && this.buttonPressed === true) return;
			this.buttonPressed = true;

			if (this.moveButton) this.container.y = this.oldContainerY;
			else this.container.setAlpha(1.0);
			m.playAudio('pop');
			gameSetTimeout(pointerUpFunction, 150);
		});

		buttonContainer.hitButton = hitButton;
		return buttonContainer;
	}

	// -------------- dice zoom
	showZoomer(diceNum) {
		console.log('8158 UI showZoomer')
		if (m.zoomerContainer != null) {
			m.zoomerContainer.destroy();
			m.zoomerContainer = null;
		}
		var diceObjects = m.diceHand.dice;
		var d = diceObjects[diceNum];
		m.zoomerContainer = m.scene.add.container(d.homePosition.x, d.homePosition.y);
		m.zoomerContainer.setDepth(3);
		var scale = m.oldAssetScaleFactor;

		var zoomerBack = m.scene.add.sprite(0, 0, 'zoomer');
		zoomerBack.setScale(scale);
		zoomerBack.setFrame(1);
		m.scoreCardElements.push(zoomerBack);
		m.zoomerContainer.add(zoomerBack);

		var targetSize = 50 * m.scaleFactor;
		var tinyX = -targetSize / 2;
		var tinyY = -(targetSize * 2) / 2;
		tinyY -= 2;
		for (let i = 0; i < 6; i++) {
			//var tinyDice1 = m.scene.add.sprite(tinyX, tinyY, store.custom.dice + '_dice2D_sheet');
			var tinyDice1 = m.scene.add.sprite(tinyX, tinyY, 'dice2D_sheet');
			var num = diceNum * 6 + i;
			tinyDice1.setFrame(num);
			m.scoreCardElements.push(tinyDice1);
			tinyDice1.setScale(targetSize / tinyDice1.width);
			if(i != d.currentFace)
				tinyDice1.setTint(0xa8a8a8);
			m.zoomerContainer.add(tinyDice1);
			m.diceInstances.add(tinyDice1);
			tinyX += targetSize;
			if (tinyX > targetSize / 2) {
				tinyX = -targetSize / 2;
				tinyY += targetSize;
			}
		}

		var ring = m.scene.add.sprite(0, 0, 'zoomer');
		ring.setScale(scale);
		m.scoreCardElements.push(ring);
		m.zoomerContainer.add(ring);

		m.lastZoomedDice = diceNum;
	}
	zoomZoomer(y) {
		console.log('8158 UI zoomZoomer')
		if (m.lastZoomerTween != null) m.lastZoomerTween.stop();
		m.lastZoomerTween = m.scene.tweens.add({
			targets: [m.zoomerContainer],
			y: y,
			scaleX: 1.3,
			scaleY: 1.3,
			ease: 'Linear',
			duration: 130,
			repeat: 0,
		});
	}
	unZoomZoomer(y) {
		console.log('8158 UI unZoomZoomer')
		if (m.lastZoomerTween != null) m.lastZoomerTween.stop();
		m.lastZoomerTween = m.scene.tweens.add({
			targets: [m.zoomerContainer],
			y: y,
			scaleX: 1.0,
			scaleY: 1.0,
			ease: 'Linear',
			duration: 130,
			repeat: 0,
		});
	}
	//centerZoomButton = null;
	showZoomButton() {
		console.log('8158 UI showZoomButton')
		//let clear = null;
		const createZoomBtn = (homeX, homeY, onClick) => {
			const shift = 5;
			const btn = m.scene.add.sprite(homeX, homeY, 'button_zoom')
				.setScale(m.oldAssetScaleFactor)
				.setDepth(3);
			const bou = btn.getBounds();
			m.scene.add.zone(bou.centerX, bou.centerY+shift/2, bou.width, bou.height + shift)
				.setDepth(40)
				.setInteractive()
				.on('pointerdown', (p) => {
					if(btn.visible) {
						btn.y += shift;
						m.playAudio('poop');
					}
				})
				.on('pointerout', () => {
					btn.y = homeY;
				})
				.on('pointerup', () => {
					//if(clear)	clear();
					if(btn.visible) {
						onClick();
					}
				})
			btn.homeX = homeX;
			btn.homeY = homeY;
			return btn;
		}

		const offset = 0;
		m.ui.zoomButtonTop = createZoomBtn(33 * m.scaleFactor, m.handBannerPosition + offset, m.ui.doZoomButtonUp)
		m.scoreCardElements.push(m.ui.zoomButtonTop);

		m.ui.zoomButtonCenter = createZoomBtn(
			m.ui.selectDiceMsg.getBounds().left - 20,
			m.diceHand.dice[5].defaultHomePosition.y + m.diceActualWidth * 1.85,
			//m.ui.selectDiceMsg.x - m.ui.selectDiceMsg.width * m.ui.selectDiceMsg.scaleX * 0.45, 
			//m.ui.selectDiceMsg.y, 
			m.ui.doZoomButtonUp
		).setFrame(1).setVisible(false).setOrigin(1, 0);
		m.scoreCardElements.push(m.ui.zoomButtonCenter);

		Tips.showTip(Tips.NAMES.ZOOM, 
			m.diceHand.dice[7].defaultHomePosition.y + m.diceActualWidth * 1.25
		)
		/* const seen = localStorage.getItem('zoomHintSeen');
		// 8089 - conditions to show Zoom hint
		const match = store.activeMatch
		if (!seen
			&& match.roundCount === 9	// not mini game
			&& match.handNumber === 7	// 1st hand of 3rd round
		) {
			const dim = m.scene.add.graphics().setDepth(3);
			dim.fillStyle(0x000000, 0.5);
			dim.lineTo(0, 0).lineTo(m.config.width, 0).lineTo(m.config.width, m.config.height).lineTo(0, m.config.height).lineTo(0, 0);
			dim.arc(m.ui.zoomButtonTop.x, m.ui.zoomButtonTop.y, 75, -Math.PI, Math.PI, true);
			dim.closePath().fill();

			const hit = m.scene.add.zone(m.config.width/2, m.config.height/2, m.config.width, m.config.height)
				.setDepth(39)
				.setInteractive({hitArea: dim})
				.on('pointerdown', () => {}) 

			const arrow = m.scene.add.sprite(m.ui.zoomButtonTop.x, m.ui.zoomButtonTop.y + 175, 'common', 'arrow_gold.png')
				.setDepth(3).setScale(0.5*m.scaleFactor);
			m.scene.tweens.add({targets: arrow,
				y: m.ui.zoomButtonTop.y + 125, 
				duration: 1000, repeat: -1, yoyo: true
			})

			const ava = m.ui.slideOnTrainingMsg(6, 725);
			const box = ava[1].getBounds();
			const btn = m.scene.add.image(box.right - 25, box.top-m.config.height/2, 'btn_close')
				.setDepth(42)
				.setInteractive({useHandCursor: true})
				.setAlpha(0)
			
			clear = () => {
				window.setPersistentStorage('zoomHintSeen', true);
				[dim, arrow, ...ava, btn, hit].forEach(v => {
					v.destroy();
				})
				clear = null;
			}
			btn.once('pointerup', clear)
			setTimeout(() => {btn.setAlpha(1)}, 300)
		} */
	}
	doZoomButtonUp() {
		console.log('8158 UI doZoomButtonUp')
		m.ui.zoomButtonTop.y = m.ui.zoomButtonTop.homeY;
		m.ui.zoomButtonCenter.y = m.ui.zoomButtonCenter.homeY;

		const noZoom = m.zoomerContainer == null;
		m.ui.zoomButtonCenter.setVisible(noZoom);
		m.ui.zoomButtonTop.setFrame(noZoom ? 1 : 0);

		if (store.tutorialMode && store.tutorialState === 'handInfo') {
			store.tutorialState = '';
			store.tutorialPreventRoll = false;
			store.m.cup.reallyReturnCup(true);
		}
		m.playAudio('pop');

		if (m.zoomerContainer == null) {
			m.ui.showZoomer(4);
			m.cup.hideCup();
			m.popper.hide();
			if (m.ui.selectDiceMsg != null) {
				m.ui.showSelectDiceMsg(1)
			}
		} else {
			m.zoomerContainer.destroy();
			m.zoomerContainer = null;
			if (m.ui.selectDiceMsg != null) {
				m.ui.showSelectDiceMsg(0);
			}
			if(!store.custom.usePopper)
				m.cup.reallyFakeReturnCup(true);
			else	m.popper.show(true)
		}
	}

	selectDiceMsg = null;
	showSelectDiceMsg(textIndex = 0) {
		console.log('8158 UI showSelectDiceMsg')

		const diceFaces = store.activeMatch.currentHand.diceFaces;
		const wildIndex = diceFaces.indexOf("Xj") > 0 ? diceFaces.indexOf("Xj") : diceFaces.indexOf("Yj")
		if(!Tips.tipShown(Tips.NAMES.WILD) && wildIndex >= 0) {
			const diceImage = m.diceHand.dice[wildIndex].diceImage
			Tips.showTip(Tips.NAMES.WILD, 
				m.diceHand.dice[7].defaultHomePosition.y + m.diceActualWidth * 1.25, 
				diceImage.getBounds())
		}


		if(m.ui.selectDiceMsg) {	// clear previous instance
			const ind = m.scoreCardElements.indexOf(m.ui.selectDiceMsg)
			if(ind >= 0)	m.scoreCardElements.splice(ind, 1)
			m.ui.selectDiceMsg.destroy();
		}
		m.ui.selectDiceMsg = textIndex === 1
			? m.ui.createUnderDiceText('hint_zoom', 25, 0)
			: m.ui.createUnderDiceText('hint_tap', 0, -40)
		if (store.tutorialMode) m.ui.selectDiceMsg.setAlpha(0);
	}
	createUnderDiceText(textKey = 'hint_tap', addX = 0, addY = 0) {
		var yPos = m.diceHand.dice[5].defaultHomePosition.y + m.diceActualWidth * 1.85;
		const txt = m.scene.add.text(m.config.width/2 + addX, yPos + addY, i18n.t(textKey), {
			font: '900 45px ' + m.ui.dodFontFamily,
			fill: '#fffffd',
			shadow: { offsetX: 0, offsetY: 4, color: '#00000059', blur: 0, stroke: false, fill: true }
		}).setOrigin(0.5, 0)
		m.scoreCardElements.push(txt)
		return txt
	}

	showFTUE2RollsHint() {
		console.log('8158 UI showFTUE2RollsHint')
		let offset = (m.cup.cupSprite.height * m.cup.cupSprite.scaleY) / 2;
		let cup2 = m.scene.add.sprite(m.cup.cupSprite.x, m.cup.cupSprite.y, 'common', 'cup_circle_2_uncropped.png');
		cup2.setScale(m.cup.cupSprite.scaleX);
		cup2.setOrigin(0.5, 0.05);
		m.scoreCardElements.push(cup2);

		let xOffset = m.cup.cupSprite.x < m.config.width / 2 ? 270 : -450;
		
		let evapTween = m.scene.tweens.add({
			targets: [cup2],
			x: m.cup.cupSprite.x + xOffset,
			y: (m.cup.cupSprite.y + 300) - offset,
			ease: 'Linear',
			duration: 500,
			repeat: 0,
			completeDelay: 0,
			onComplete: (tween, target) => {
				let twoMoreRolls = m.scene.add.sprite(cup2.x+200, cup2.y+offset*0.9, 'language', 'tutorial_2_more_rolls.png');
				twoMoreRolls.setScale(1.25);
				m.scoreCardElements.push(twoMoreRolls);
				setTimeout(() => {
					m.cup.waitForFTUE = false;
				}, 500);
			},
		});
		m.scoreCardTweens.push(evapTween);
	}

	epicBanner = null;
	endOfShortTutorial() {
		console.log('8158 UI endOfShortTutorial')
		var diceObjects = m.diceHand.dice;
		var epicYPos = diceObjects[5].defaultHomePosition.y - m.diceActualWidth * 0.7;
		m.ui.epicBanner = m.scene.add.sprite(
			m.config.width / 2,
			epicYPos - m.config.height / 2,
			'short_tutorial_banner_epic'
		);
		m.ui.epicBanner.setScale(m.oldAssetScaleFactor * 0.7);
		m.ui.epicBanner.setDepth(2);
		// m.playAudio('epic_win');
		// m.playAudio('EpicWin_smaller_v1');

		m.scene.tweens.add({
			targets: [m.ui.epicBanner],
			y: epicYPos + 30,
			ease: 'Linear',
			duration: 300,
			repeat: 0,
			delay: 0,
			completeDelay: 0,
			onComplete: (tween, target) => {
				m.scene.tweens.add({
					targets: [m.ui.epicBanner],
					y: epicYPos,
					ease: 'Linear',
					duration: 50,
					repeat: 0,
					delay: 0,
					completeDelay: 0,
					onComplete: (tween, target) => {
						var diceObjects = m.diceHand.dice;
						var yPos = diceObjects[5].defaultHomePosition.y + m.diceActualWidth * 1.75;
						yPos += 75;
						let bannerContainer = m.scene.add.container(m.config.width / 2, yPos + m.config.height);

						if(store.activeMatch.matchId === 'intro') {
							let resultsBanner = m.scene.add.sprite(0, 0, 'tutorial', 'tutorial_box_too_easy_no_banner.png');
							resultsBanner.setScale(m.oldAssetScaleFactor);
							yPos += resultsBanner.height * resultsBanner.scaleY * 0.4;
							bannerContainer.add(resultsBanner);
							bannerContainer.setDepth(0);

							let practice = m.ui.createButton(
								'btn_roll_again.png',
								0,
								m.adjustY(65),
								255 * m.scaleFactor,
								m.ui.defaultButtonHeight * 1.5 * 0.85,
								'roll-again',
								function (pointer) {
									console.log('pressed roll again button');

									resultsBanner.destroy();
									bannerContainer.destroy();
									m.ui.epicBanner.destroy();

									store.tutorialMode = true;
									//store.preventReturnToSplash = true;
									comm.ResetTutorial(new TutorialServer(3)); //2nd FTUE hand start
									history.push(`/game/tutorial/play`);
								}
							);
							m.ui.makePulsate(practice);
							bannerContainer.add(practice);
						} else {
							m.ui.royalFlushBanner.setAlpha(0);
							m.ui.royalFlushBack.setAlpha(0);
		
							store.modal = 'ftueCollectHearts';
							//store.topBar.showHeart = true;
						}
						
						m.scene.tweens.add({
							targets: [bannerContainer],
							y: yPos,
							ease: 'Linear',
							duration: 300,
							repeat: 0,
							delay: 0,
							completeDelay: 0,
							onComplete: (tween, target) => {},
						});
					},
				});
			},
		});
	}
	royalFlushBanner = null;
	royalFlushBack = null;
	showBigWinBanner = () => {
		console.log('8158 UI showBigWinBanner')
		var diceObjects = m.diceHand.dice;
		var handName =
			(store.activeMatch.matchId === 'intro' || store.activeMatch.matchId === 'intro2') ? 'four-of-a-kind' : store.activeMatch.goals[store.activeMatch.handNumber - 1];
		if (!handName || handName == null || (handName == undefined && typeof store.activeMatch.currentHand.bestHandTargetString != 'undefined'))
			handName = store.activeMatch.currentHand.bestHandTargetString;
		if (store.activeMatch.handNumber >= store.activeMatch.roundCount && (!handName || handName == null || handName == undefined)) {
			let sIndex = store.activeMatch.currentHand.bestHandTarget;
			handName = m.hands[sIndex];
		}
		var frame = store.activeMatch.currentHand.best ? 0 : m.handBannerHandNames.indexOf(handName);
		let jackpot = frame < 0 && store.activeMatch.handNumber >= store.activeMatch.roundCount;

		if (store.settings.handStrengthMeter === undefined) store.settings.handStrengthMeter = false;
		if (store.settings.handStrengthMeter === true) store.settings.handStrengthMeter = false;

		var yPos = diceObjects[5].defaultHomePosition.y + m.diceActualWidth * 1.825; // 1.75;

		if (store.activeMatch.currentHand.isWinningHand || jackpot || store.settings.handStrengthMeter) {
			if (store.tutorialMode) m.ui.killGoalArrow();
			if (store.activeMatch.currentHand.isWinningHand) {
				m.diceHand.unlockAllDice();
				store.activeMatch.currentHand.match.forEach((d) => {
					diceObjects[d].addFlair('flair' ,store.settings.theme);
					diceObjects[d].locked = true;
				});
				m.diceHand.darkenUnlockedDice();
			}
			if (frame >= 0 || jackpot || store.settings.handStrengthMeter) {
				if (store.settings.handStrengthMeter) {
					let handStrength = 0;
					if (store.activeMatch.currentHand.handStrength != undefined && store.activeMatch.currentHand.isWinningHand) {
						handStrength = Math.round(store.activeMatch.currentHand.handStrength * 6);
					}
					//let meterType = store.AB_TEST_handStrengthMeter ? 'bar' : 'stars';
					var bigWinBack = m.scene.add.sprite(
						m.config.width / 2,
						yPos,
						//'banner_meter_' + meterType + '_' + handStrength
						'banner_meter_stars_' + handStrength
					);

					let msg = 'server: ' + store.activeMatch.currentHand.handStrength + ' game: ' + handStrength;
					let debugText = m.scene.add.text(150, yPos + bigWinBack.height * 0.3, msg, {
						fontFamily: m.ui.dodFontFamily,
						fontSize: '28px',
						fill: '#ffffff',
						stroke: '#0',
						strokeThickness: 2,
						wordWrap: { width: 800 },
					});
					m.scoreCardElements.push(debugText);
				} else {
					if (frame >= 0) {
						var bigWinBack = m.scene.add.sprite(m.config.width / 2, yPos, 'common', 'big_win_banner_x2.png');
					} else {
						var bigWinBack = m.scene.add.sprite(m.config.width / 2, yPos, 'language', 'big_win_two_pair_or_better.png');
					}
				}

				bigWinBack.setScale(
					store.settings.handStrengthMeter ? (640 / bigWinBack.width) * m.oldAssetScaleFactor : frame >= 0 ? m.oldAssetScaleFactor * 0.5 : m.oldAssetScaleFactor
				);
				bigWinBack.setDepth(1);
				m.scoreCardElements.push(bigWinBack);

				if ((frame >= 0 && store.activeMatch.currentHand.isWinningHand) || store.settings.handStrengthMeter) {
					const bigWinBanner = addHandName(
						m.config.width/2 + (store.settings.handStrengthMeter ? 90 : 0),
						yPos - 5 - (store.settings.handStrengthMeter ? 20 : 7),
						handName, 70, 500
					).setDepth(1);
					m.scoreCardElements.push(bigWinBanner);

					m.ui.royalFlushBanner = bigWinBanner;
					m.ui.royalFlushBack = bigWinBack;

					m.floatingStars = m.scene.add.sprite(bigWinBack.x, bigWinBack.y, 'floatingStars001');
					m.floatingStars.setScale(1.0);
					m.floatingStars.setDepth(3);
					m.floatingStars.anims.play('floatingStars');
					m.scoreCardElements.push(m.floatingStars);
				}
			}

			if (store.activeMatch.currentHand.isWinningHand)
				m.playAudio(store.activeMatch.currentHand.best ? 'Winner_v3' : 'twinkle');

			if ((store.activeMatch.currentHand.best 
				&& handName !== 'all-red' && handName !== 'all-black')  
				|| (store.tutorialMode && 
					(store.activeMatch.matchId === 'intro' 
					|| store.activeMatch.matchId === 'intro2'))
			) {
				m.diceHand.resolveGridToHorizontal();
			}

		} else {
			if(!store.activeMatch.currentHand.isWinningHand && !store.tutorialMode) {
				m.ui.showNoHandBanner();
			}
		}
	};
	showNoHandBanner = () => {
		console.log('8158 UI showNoHandBanner')
		var yPos = m.diceHand.dice[5].defaultHomePosition.y + m.diceActualWidth * 1.825; // 1.75;
		var bigWinBack = m.scene.add.sprite(m.config.width / 2, yPos, 'common', 'big_win_banner_x2.png');
		bigWinBack.setScale(m.oldAssetScaleFactor*0.5);
		bigWinBack.setDepth(1);
		m.scoreCardElements.push(bigWinBack);
		if(store.pokerRush)
			return;

		const bigWinBanner = addHandName(m.config.width * 0.5, yPos - 9, 'goal_not_achieved', 70, 500).setDepth(1)
		m.scoreCardElements.push(bigWinBanner);
	}

	continueButtonHasBeenPressed = false;
	continueButtonContainer = null;
	buttonPinkHeart = null;
	button2 = null;

	animatePinkHeart = (hearts) => {
		console.log('8158 UI animatePinkHeart')
		const {x, y} = m.ui.buttonPinkHeart.getBounds();
		store.showHeartsSpend = {x, y, num:hearts};
	};

	finishExtraRoll = () => {
		console.log('8158 UI finishExtraRoll')
		m.clearMessages();
		if (store.activeMatch.currentHand.isWinningHand) {
			m.diceHand.resumeFromHeart();
		}
		//m.cup.returnCup();
		m.allDiceResolved();
	};
	finishHandReset = () => {
		console.log('8158 UI finishHandReset')
		m.clearMessages();
		m.diceHand.unlockAllDice();
		m.diceHand.clearDiceOffScreen();
		store.activeMatch.currentHand.rollNumber = 0;
		m.cup.returnCup();
	};

	showPlayHandButton = () => {
		console.log('8158 UI showPlayHandButton')
		m.cup.waitForHandPointer = false;

		let yMod = 0.72;
		let tutPlayOnly = false;
		let shouldPulse = false;
		let isEligibleForRewardRoll = store.isEligibleForRewardRoll;

		if (store.tutorialMode) {
			if (store.activeMatch.handNumber < 3) {
				const boxY = m.adjustY(852) * m.ui.avaPanelPos + 68 * m.scaleFactor;
				if (store.activeMatch.handNumber === 1) {
					yMod = 0.9;
					m.ui.createTutorialBox('skilz_tutorial_1_3', boxY)
					shouldPulse = true;
					m.skipTutorial.setAlpha(0);
				} 
				else if (store.activeMatch.handNumber === 2) {
					if (store.activeMatch.currentHand.rollNumber === 3) {
						yMod = 0.9;
						m.ui.createTutorialBox('skilz_tutorial_2_4', boxY)
						shouldPulse = true;
					} else 
						shouldPulse = true;
				}
			} else if (store.activeMatch.handNumber === 3) {
				shouldPulse = true;
				m.ui.createTutorialBox('skilz_tutorial_3_2', m.config.height * 0.275)
			}

			tutPlayOnly =
				store.activeMatch.handNumber === 1 ||
				(store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 4);
			if (store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 3) {
				store.tutorialState = 'noflush';
			}
			if (store.activeMatch.handNumber === 2 && store.activeMatch.currentHand.rollNumber === 4) {
				store.tutorialState = 'freerollworked';
			}
		}

		let playOrSkip =
			!store.canUseExtraRoll && store.canUseHandReset && !store.is1HandGame && !store.activeMatch.currentHand.isWinningHand
				? false
				: isEligibleForRewardRoll && !store.activeMatch.currentHand.isWinningHand
				? false
				: store.playOrSkip;
		let playHandButtonText = playOrSkip ? 'play-hand' : 'continue';

		//4th roll miss button should say 'continue':
		if (!store.activeMatch.currentHand.isWinningHand && store.activeMatch.currentHand.rollNumber > 3) {
			playHandButtonText = 'continue';
		}

		const defaultBtnWidth = 960*0.95; // m.config.width *0.8;
		const scaleToFitLongText = 1;//0.9;
		m.playHandButtonPressed = false;
		m.extraRollButtonPressed = false;
		var button = m.ui.createButton(
			'btn_play_hand.png', 0, 0,
			defaultBtnWidth * ((store.activeMatch.currentHand.best || store.is1HandGame) ? 0.5 : 0.4),
			m.ui.defaultButtonHeight * ((store.activeMatch.currentHand.best || store.is1HandGame) ? 1.35 : 1 *scaleToFitLongText),
			playHandButtonText,
			()=> {
				console.log('pressing play/skip...');

				if (store.tutorialMode && store.activeMatch.handNumber === 2 && playHandButtonText === 'continue') return;

				if (m.playHandButtonPressed === true || m.extraRollButtonPressed === true) {
					console.log('play/skip already pressed');
					return;
				}
				m.playHandButtonPressed = true;
				integration.postEvent('play_hand', 'gameplay', store.activeMatch.handNumber);
				if (store.tutorialMode && store.activeMatch.handNumber === 1) {
					store.tutorialState = '';
				}
				if (store.tutorialMode && store.activeMatch.handNumber === 2) {
					store.tutorialState = '';
					if (store.canUseExtraRoll) return;
				}

				//m.cup.returnCup();
				store.getGameState().then(() => {
					console.log(' ---------------- go to score :: am =', store.activeMatch, 'ch =', store.activeMatch.currentHand)
					//m.ui.multiChip.opacity = 0;
					this.showScorecard(store.activeMatch.handNumber, false);
				})

				return;
			}
		);
		if (shouldPulse) m.ui.makePulsate(button);
		else if (store.tutorialMode) m.skipTutorial.setAlpha(0);

		const buttonContainer = m.scene.add.container(0, m.adjustY(852) * yMod);
		button.setX(button.getBounds().width/2);
		buttonContainer.add(button);
		m.scoreCardElements.push(buttonContainer);

		/* if (!store.activeMatch.currentHand.best && !store.is1HandGame && !(playOrSkip && store.tutorialMode)) {
			// actions
			if(!store.isFirstTimePractice && store.canUseExtraRoll)
				integration.postEvent('bonus_roll_shown', 'gameplay', store.activeMatch.handNumber)
			
			// create button
			const bonusRollCost = store.tutorialMode ? 1 :
				store.canUseHandReset ? store.resetHandCost : store.activeMatch.freeRollCost;
			const addRoll = () => {
				if (m.playHandButtonPressed === true || m.extraRollButtonPressed === true) {
					console.log('play/skip already pressed');
					return;
				}
				if (store.showProductStore) return;

				if (store.canUseExtraRoll) {
					m.extraRollButtonPressed = true;

					if(!store.isFirstTimePractice)
						integration.postEvent('bonus_roll_used', 'gameplay', store.activeMatch.handNumber);
					// if(store.is1or3HandGame) {
					// 	comm.UseFreeRoll(store.activeMatch.matchId)
					// 	.then(() => {
					// 		store.activeMatch.currentHand.rollsRemaining = 1;
					// 		// m.playAudio('BonusHeart'); //_option4");
					// 		gameSetTimeout(m.ui.finishExtraRoll, 150);
					// 	})
					// 	.catch((err) => {
					// 		console.log('comm.canUseFreeRoll err:' + err);
					// 	});
					// } else
					 {
						if (store.skillzHearts > 0) {
							comm.UseFreeRoll(store.activeMatch.matchId)
								.then(() => {
									store.activeMatch.useHeart();
									if (store.tutorialMode) {
										store.skillzHearts += bonusRollCost;
									}

									m.playAudio('BonusHeart'); //_option4");
									m.ui.animatePinkHeart(bonusRollCost);
									gameSetTimeout(m.ui.finishExtraRoll, 1500);
								})
								.catch((err) => {
									console.log('comm.canUseFreeRoll err:' + err);
								});
						} else {
							//m.showProductStore();
							m.extraRollButtonPressed = false;
							m.ui.button2.hitButton.buttonPressed = false;
						}
					}
				} else {
					if(store.is1HandGame)
						return;
						
					if(store.is3HandGame) {
						m.ui.slideOnTrainingMsg(5);
						return;
					}
				
					store.modal = 'heartszero';
					m.extraRollButtonPressed = false;
				}
				return;
			}
			const resetHand = () => {
				if (m.playHandButtonPressed === true || m.extraRollButtonPressed === true) {
					console.log('play/skip already pressed');
					return;
				}
				m.extraRollButtonPressed = true;

				comm.UseHandReset(store.activeMatch.matchId)
				.then(() => {
					store.activeMatch.useHandReset();
					m.playAudio('BonusHeart'); //_option4");
					m.ui.animatePinkHeart(store.resetHandCost);
					gameSetTimeout(m.ui.finishHandReset, 1500);
				})
				.catch((err) => {
					console.log('comm.canApplyHandReset err:' + err);
				});
			}

			const buttonText = store.canUseHandReset ? 'restart-hand' : 
				store.is1HandGame ? 'extra-roll' : 'bonus-roll';
			const buttonColor = (store.canUseHandReset || store.canUseExtraRoll) ? 'green' : 'gray';
			const buttonIcon = store.is1HandGame ? '' : 'small_star.png';
			m.ui.button2 = m.ui.createButton(
				'add-roll-button', 0, 0,
				defaultBtnWidth * 0.425,
				m.ui.defaultButtonHeight *scaleToFitLongText,
				buttonText,
				store.canUseHandReset ? resetHand : addRoll,
				buttonColor, buttonIcon,
			);
			m.ui.button2.normalScale = m.ui.button2.scaleX;
			buttonContainer.add(m.ui.button2);
			m.ui.button2.setX(button.getBounds().right + m.ui.button2.getBounds().width/2);

			if(store.canUseExtraRoll || store.canUseHandReset)
				m.ui.addGlowToButton(m.ui.button2);

			// pink heart icon
			if(!store.is1HandGame) {
				m.ui.buttonPinkHeart = m.scene.add.sprite(
					-85 * m.scaleFactor, 
					2 * m.scaleFactor, 'common', 
					(store.canUseExtraRoll || store.canUseHandReset) ? 'btn_icon_heart_rotated_phaser.png' : 'btn_icon_heart_rotated_gray.png'
				);
				m.ui.buttonPinkHeart.setScale(scaleToFitLongText);
				m.ui.buttonPinkHeart.setX(m.ui.buttonPinkHeart.width/2 - m.ui.button2.getBounds().width/2);
				m.ui.button2.add(m.ui.buttonPinkHeart);

				const buttonPinkHeartText = m.scene.add.text(
					m.ui.buttonPinkHeart.x + 5, m.ui.buttonPinkHeart.y +5, 
					bonusRollCost, {
						fontFamily: m.ui.dodFontFamily,
						fontSize: 56 *scaleToFitLongText + 'px',
						fill: '#ffffff',
						//stroke: '#0', strokeThickness: 2,
						shadow: { offsetX: 0, offsetY: 3, color: '#686868', blur: 0, stroke: false, fill: true }
					}
				);
				buttonPinkHeartText.setOrigin(0.5, 0.5);
				buttonPinkHeartText.angle = -15;
				m.ui.button2.add(buttonPinkHeartText);
				// m.ui.buttonPinkHeart.setAlpha(0);
			}

			if(!store.tutorialMode && !store.is1HandGame) {
				if(store.canUseHandReset) {
					this.showRestartHandReminderMsg();
				} else if(store.canUseExtraRoll) {
					this.showExtraRollReminderMsg();
				}
			}

			if (
				(store.canUseExtraRoll || (store.activeMatch.canUseHandReset && !store.canUseExtraRoll)) &&
				store.skillzHearts >= 0 && !store.is1HandGame
			) {
				var evapTween = m.scene.tweens.add({
					targets: [m.ui.button2],
					scaleX: m.ui.button2.scaleX * 1.2,
					scaleY: m.ui.button2.scaleY * 1.2,
					ease: 'Linear',
					delay: 350,
					duration: 350,
					yoyo: true,
				});
				m.scoreCardTweens.push(evapTween);
			}
		} */
		buttonContainer.setX(m.config.width/2 - buttonContainer.getBounds().width/2);
	};

	showExtraRollReminderMsg() {
		console.log('8158 UI showExtraRollReminderMsg')
		if(store.is1HandGame)
			return;
	
		let extraRollButtonShownCount = 1;
		if (!localStorage.getItem('extraRollButtonShownCount'))
			window.setPersistentStorage('extraRollButtonShownCount', '1');
		else {
			extraRollButtonShownCount = parseInt(localStorage.getItem('extraRollButtonShownCount'));
			extraRollButtonShownCount++;
			window.setPersistentStorage('extraRollButtonShownCount', extraRollButtonShownCount.toString());
		}
		console.log('***** EXTRA ROLL COUNT: ' + extraRollButtonShownCount);

		let myHand = store.activeMatch.hands[store.activeMatch.handNumber-1];
		let validHand = myHand.match && myHand.match.length > 2;
		let showMsg = false;

		if(store.is3HandGame) {
			if(!myHand.best) {
				if(store.activeMatch.opponent.isBot) {
					if (!localStorage.getItem('3HandBonusRollHintShownBot'))
					 {
						window.setPersistentStorage('3HandBonusRollHintShownBot', 'true');
						m.ui.slideOnTrainingMsg(4);
					}
				} else {
					if (!localStorage.getItem('3HandBonusRollHintShownPvp')) 
					{
						window.setPersistentStorage('3HandBonusRollHintShownPvp', 'true');
						m.ui.slideOnTrainingMsg(4);
					}
				}
			}
			return;
		}

		/* if(!validHand) {
			if (!localStorage.getItem('firstTimeNoGoalAfter3Rolls')) {
				if (!localStorage.getItem('firstTimeGoalNotBest')) //(3rd msg ever shown?)
					showMsg = true;
				else {
					if(localStorage.getItem('firstTimeGoalNotBest') !== store.activeMatch.matchId.toString())
						showMsg = true;
				}
				if(showMsg) {
					window.setPersistentStorage('firstTimeNoGoalAfter3Rolls', store.activeMatch.matchId);
					m.ui.slideOnTrainingMsg(0);
				}
				return;
			}
		} else {
			if(!myHand.best) {
				if (!localStorage.getItem('firstTimeGoalNotBest')) {
					if (!localStorage.getItem('firstTimeNoGoalAfter3Rolls')) 
						showMsg = true;
					else {
						if(localStorage.getItem('firstTimeNoGoalAfter3Rolls') !== store.activeMatch.matchId.toString())
							showMsg = true;
					}
					if(showMsg) {
						window.setPersistentStorage('firstTimeGoalNotBest', store.activeMatch.matchId);
						m.ui.slideOnTrainingMsg(2);
					}
					return;
				}
			}
		} */
	}
	showRestartHandReminderMsg() {
		console.log('8158 UI showRestartHandReminderMsg')
		if(store.is1or3HandGame)
			return;

		let restartHandButtonShownCount = 1;
		if (!localStorage.getItem('restartHandButtonShownCount'))
			window.setPersistentStorage('restartHandButtonShownCount', '1');
		else {
			restartHandButtonShownCount = parseInt(localStorage.getItem('restartHandButtonShownCount'));
			restartHandButtonShownCount++;
			window.setPersistentStorage('restartHandButtonShownCount', restartHandButtonShownCount.toString());
		}
		console.log('***** RESTART HAND COUNT: ' + restartHandButtonShownCount);

		let myHand = store.activeMatch.hands[store.activeMatch.handNumber-1];
		let validHand = myHand.match && myHand.match.length > 2;

		if(!validHand) {
			if (!localStorage.getItem('firstTimeNoGoalAfterBonusRoll')) {
				window.setPersistentStorage('firstTimeNoGoalAfterBonusRoll', '1');
				m.ui.slideOnTrainingMsg(1);
				return;
			}
		} else {
			if(!myHand.best) {
				if (!localStorage.getItem('firstTimeUseBonusRollNotBest')) {
					window.setPersistentStorage('firstTimeUseBonusRollNotBest', '1');
					m.ui.slideOnTrainingMsg(3);
					return;
				}
			}
		}


		// this.showTrainingMsg(this.restartHint);
		// if(this.restartHint === 1)
		// 	this.restartHint = 3;
		// else 
		// 	this.restartHint = 1;

		// let showMsg = false;
		// if (store.user.level <= 4) {
		// 	if (numTimesShown % 5 == 0) showMsg = true;
		// } else if (store.user.level <= 8) {
		// 	if (numTimesShown % 10 == 0) showMsg = true;
		// } else if (store.user.level === 15) {
		// 	if (!localStorage.getItem('restartHandReminderMsgShownLevel15')) {
		// 		window.setPersistentStorage('restartHandReminderMsgShownLevel15', 'true');
		// 		showMsg = true;
		// 	}
		// } else if (store.user.level === 20) {
		// 	if (!localStorage.getItem('restartHandReminderMsgShownLevel20')) {
		// 		window.setPersistentStorage('restartHandReminderMsgShownLevel20', 'true');
		// 		showMsg = true;
		// 	}
		// } else return;
		// if (store.hasPurchasedIAP === 'true') return;
		// if (!showMsg) return;

		// let restartHandReminderMsgNumber = 1;
		// if (!localStorage.getItem('restartHandReminderMsgNumber'))
		// 	window.setPersistentStorage('restartHandReminderMsgNumber', '1');
		// else {
		// 	restartHandReminderMsgNumber = parseInt(localStorage.getItem('restartHandReminderMsgNumber'));
		// 	if (++restartHandReminderMsgNumber > 2) restartHandReminderMsgNumber = 1;
		// 	window.setPersistentStorage('restartHandReminderMsgNumber', restartHandReminderMsgNumber.toString());
		// }
		// console.log('***** restartHandReminderMsgNumber: ' + restartHandReminderMsgNumber);
		// let type = 'incentive_restart_' + (restartHandReminderMsgNumber == 1 ? '1' : '2');

		// m.ui.slideOnTrainingMsg(this.restartHint);
	}

	slideOnTrainingMsg(type, in_y = 852) {
		console.log('8158 UI slideOnTrainingMsg')
		if(store.canUseExtraRoll)
			m.ui.activateGlowButton(m.ui.button2);

		let isPhone = store.aspectIs('Tall') || store.aspectIs('Standard');
		let y = m.adjustY(in_y) * 0.72 - 40;		// magic numbers for good view
		let trainingMsg = m.scene.add.sprite(m.config.width / 2 - m.config.width, 0, 'ava_hint_body');
		trainingMsg.setScale((m.config.width / trainingMsg.width) * (isPhone ? 1.0 : 0.75));
		y = Math.max(y, m.config.height - trainingMsg.getBounds().height);
		trainingMsg.setY(y);
		trainingMsg.setOrigin(0.5, 0);
		trainingMsg.setDepth(7);
		m.scoreCardElements.push(trainingMsg);
		let evapTween = m.scene.tweens.add({
			targets: [trainingMsg],
			x: m.config.width / 2,
			ease: 'Linear',
			duration: 250,
			repeat: 0,
		});
		m.scoreCardTweens.push(evapTween);

		let y2 = y + 150;
		let boxContainer = m.scene.add.container(m.config.width * 0.66, y2+m.config.height/2);
		boxContainer.setDepth(8);
		m.scoreCardElements.push(boxContainer);
		let blankbox = m.scene.add.sprite(0, 0, 'ava_hint_bubble');
		blankbox.setScale(0.72);
		blankbox.setOrigin(0.5, 0);
		boxContainer.add(blankbox);

		const addText = (x, y, text, size, weight = 500, style = 'normal') => {
			const txt = m.scene.add.text(x, y, text, {
				font: weight + ' ' + size + 'px ' + m.ui.dodFontFamily,
				fill: '#3d4284', align: 'center',
				fontStyle: style,
				// shadow: { offsetX: 0, offsetY: 3, color: '#000000', blur: 0, stroke: false, fill: true },
			});
			txt.setOrigin(0.5, 0.5);
			boxContainer.add(txt);
			return txt;
		}

		let msgs = [
			{line1: i18n.t('hint_bonus_roll_1a'), line2: i18n.t('hint_bonus_roll_1b')},
			{line1: i18n.t('hint_restart_hand_1a'), line2: i18n.t('hint_restart_hand_1b')},
			{line1: i18n.t('hint_bonus_roll_2a'), line2: i18n.t('hint_bonus_roll_2b')},
			{line1: i18n.t('hint_restart_hand_2a'), line2: i18n.t('hint_restart_hand_2b')},
			{line1: i18n.t('hint_bonus_roll_3a'), line2: i18n.t('hint_bonus_roll_3b'), line3: i18n.t('hint_bonus_roll_3c')},
			{line1: i18n.t('hint_bonus_roll_4a'), line2: i18n.t('hint_bonus_roll_4b'), line3: i18n.t('hint_bonus_roll_4c')},
			{
				line1: i18n.t('hint_zoom_6a'), 
				line1end: i18n.t('hint_zoom_6a_end_bold'), 
				line2start: i18n.t('hint_zoom_6b_start_bold'), 
				line2: i18n.t('hint_zoom_6b'), 
				line3: i18n.t('hint_zoom_6c')}
		];

		if(type === 3) {
			addText(0, 52, msgs[type].line1, 34, 400);
			addText(0, 95+20, msgs[type].line2, 34, 400);

			if(store.settings.language === 'en') {
				addText(59, 95+1, 'Bonus Points,', 34, 500, 'bold');
				addText(86, 95+41, '3 new rolls!', 34, 500, 'bold');
			}
		} else if(type === 6) {
			const size = 50;
			const t1 = addText(0, 35, msgs[type].line1, size, 400);
			const t1b = addText(0, 35, ' ' + msgs[type].line1end, size, 800);
			t1.x -= t1b.getBounds().width/2;
			t1b.x += t1.getBounds().width/2;

			const t2b =	addText(0, 95, msgs[type].line2start + ' ', size, 800);
			const t2 =	addText(0, 95, msgs[type].line2, size, 400);
			t2b.x -= t2.getBounds().width/2;
			t2.x += t2b.getBounds().width/2;

			addText(0, 155, msgs[type].line3, size, 400);
		} else {
			if(type > 3) {
				addText(0, 44, msgs[type].line1, 34, 400);
				addText(0, 95, msgs[type].line2, 44, 800);
				addText(0, 95+50, msgs[type].line3, 34, 400);
			} else {
				addText(0, 44, msgs[type].line1, 34, 400);
				addText(0, 95+30, msgs[type].line2, 44, 800);
			}
		}

		let evapTween2 = m.scene.tweens.add({
			targets: [boxContainer],
			y: y2,
			ease: 'Linear',
			duration: 250,
			delay: 50,
			repeat: 0,
		});
		m.scoreCardTweens.push(evapTween2);

		return [trainingMsg, boxContainer]
	}
}
